import {
  OPEN_TRIAL_EXCEEDED_MODAL,
  CLOSE_TRIAL_EXCEEDED_MODAL,
  OPEN_TRIAL_LIMITATIONS_MODAL,
  CLOSE_TRIAL_LIMITATIONS_MODAL,
  OPEN_SUBSCRIPTION_UPGRADE_NEEDED,
  CLOSE_SUBSCRIPTION_UPGRADE_NEEDED,
  SET_STORE_CONFIGURATION_MODAL_VISIBILITY,
  SET_CREATOR_SEARCH_LOCKED_MODAL_VISIBILITY,
  SET_OUTSIDE_CLICK_WARNING_MODAL_VISIBILITY,
} from "./globalModalsTypes";

export function openTrialExceededModal() {
  return {
    type: OPEN_TRIAL_EXCEEDED_MODAL,
  };
}

export function closeTrialExceededModal() {
  return {
    type: CLOSE_TRIAL_EXCEEDED_MODAL,
  };
}

export function openTrialLimitationsModal() {
  return {
    type: OPEN_TRIAL_LIMITATIONS_MODAL,
  };
}

export function closeTrialLimitationsModal() {
  return {
    type: CLOSE_TRIAL_LIMITATIONS_MODAL,
  };
}

export function openSubscriptionUpgradeNeededModal() {
  return {
    type: OPEN_SUBSCRIPTION_UPGRADE_NEEDED,
  };
}

export function closeSubscriptionUpgradeNeededModal() {
  return {
    type: CLOSE_SUBSCRIPTION_UPGRADE_NEEDED,
  };
}

export function setStoreConfigurationModalVisibility(
  storeConfigurationModalVisible: boolean,
) {
  return {
    type: SET_STORE_CONFIGURATION_MODAL_VISIBILITY,
    payload: { storeConfigurationModalVisible },
  };
}

export function setCreatorSearchLockedModalVisibility(
  creatorSearchLockedModalVisible: boolean,
) {
  return {
    type: SET_CREATOR_SEARCH_LOCKED_MODAL_VISIBILITY,
    payload: { creatorSearchLockedModalVisible },
  };
}

export function setOutsideClickWarningModalVisibility(
  outsideClickWarningModalVisible: boolean,
) {
  return {
    type: SET_OUTSIDE_CLICK_WARNING_MODAL_VISIBILITY,
    payload: { outsideClickWarningModalVisible },
  };
}
